/*
  FontIcon: https://react-md.mlaursen.com/components/font-icons
  Icons:    https://material.io/icons/

  <Icon name='done_all'/>  OR <Icon name={'done_all'}/>
  <Icon name='search'/>
  <Icon name={'refresh'} color={‘red’} size={"12px"}/>
 */
import React from 'react'
import {main_colors} from 'utils/colors'


const mappings = {
    threat_center: 'dashboard',
    discover: 'visibility',
    patrol: 'security',
    syndicate: 'cast',
    reports: 'library_books',
    tasks: 'list'
}
const DrIcon = (props) => {
    const icon_name = (props.name in mappings) ? mappings[props.name] : props.name
    const _style = {}
    if (props.size !== '') _style.fontSize = props.size
	  if (props.color) _style.color = props.color
    let _className = 'md-icon material-icons'
    if (props.className) _className = `${_className}  ${props.className}`
    const _onClick = props.onClick
    return(<i className={_className} style={_style} onClick={_onClick}> {icon_name} </i>)
}

export default DrIcon;
